import Vue from "vue";
import Router from "vue-router";

import COLUMN_TYPES from "@/util/columntypes";

Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err && err.name !== "NavigationDuplicated") throw err;
  });
};
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err && err.name !== "NavigationDuplicated") throw err;
  });
};

export default new Router({
  routes: [
    {
      path: "/login",
      name: "login",
      component: () => import("@/components/Login")
    },

    {
      path: "/faqs",
      name: "faqs",
      component: () => import("@/components/FAQDashboard.vue"),
      beforeEnter(to, from, next) {
        const token = window.$cookies.get("token");
        if (token) {
          next();
        } else {
          next("/login");
        }
      }
    },
    {
      path: "/",
      name: "home",
      component: () => import("@/components/Dashboard.vue"),
      children: [
        {
          path: "/book/:id?",
          name: COLUMN_TYPES[0],
          component: () => import("@/components/overlay/Book")
        },
        {
          path: "/chapter/:id?",
          name: COLUMN_TYPES[2],
          component: () => import("@/components/overlay/Chapter")
        },
        {
          path: "/competence-module/:id?",
          name: COLUMN_TYPES[3],
          component: () => import("@/components/overlay/CompetenceModule")
        },
        {
          path: "/package/:id?",
          name: COLUMN_TYPES[1],
          component: () => import("@/components/overlay/Package")
        },
        {
          path: "/school-type/:id?",
          name: COLUMN_TYPES[5],
          component: () => import("@/components/overlay/SchoolType")
        },
        {
          path: "/skill/:id?",
          name: COLUMN_TYPES[6],
          component: () => import("@/components/overlay/Skill")
        },
        {
          path: "/subject/:id?",
          name: COLUMN_TYPES[4],
          component: () => import("@/components/overlay/Subject")
        },
        {
          path: "/task/:id?",
          name: COLUMN_TYPES[7],
          component: () => import("@/components/overlay/Task")
        },
        {
          path: "/task-type/:id?",
          name: COLUMN_TYPES[8],
          component: () => import("@/components/overlay/TaskType")
        },
        {
          path: "/topic/:id?",
          name: COLUMN_TYPES[9],
          component: () => import("@/components/overlay/Topic")
        },
        {
          path: "/filter/:id?",
          name: COLUMN_TYPES[10],
          component: () => import("@/components/overlay/Filter")
        },
        {
          path: "/contentTypes/:id?",
          name: COLUMN_TYPES[11],
          component: () => import("@/components/overlay/ContentType")
        }
      ],
      beforeEnter(to, from, next) {
        const token = window.$cookies.get("token");
        if (token) {
          next();
        } else {
          next("/login");
        }
      }
    }
  ]
});
